import logger from '@utils/logger';
import { ApiError } from 'src/errors/ApiError';

let initialized = false;

const describeReason = (reason: unknown): string => {
  if (reason instanceof Error) {
    return reason.message;
  }
  if (typeof reason === 'string') {
    return reason;
  }
  try {
    return JSON.stringify(reason);
  } catch (e) {
    return String(reason);
  }
};

/**
 * Routes uncaught errors and unhandled promise rejections through the
 * structured logger so they land in the ring buffer and get the versioned,
 * timestamped console prefix that makes user screenshots traceable.
 * Sentry's own handlers still capture and report these independently.
 */
export const initGlobalErrorLogging = (): void => {
  if (initialized || typeof window === 'undefined') {
    return;
  }
  initialized = true;

  window.addEventListener('error', (event: ErrorEvent) => {
    // Resource load failures dispatch 'error' too but carry no error/message.
    if (!event.error && !event.message) {
      return;
    }
    const location = event.filename ? ` at ${event.filename}:${event.lineno}` : '';
    logger.error('window', `uncaught: ${event.message}${location}`);
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    // ApiErrors are already logged with full context by the api/base wrappers.
    if (event.reason instanceof ApiError) {
      return;
    }
    logger.error('window', `unhandled rejection: ${describeReason(event.reason)}`);
  });
};

export default initGlobalErrorLogging;
